<div id="fehlerDialog">
  <div id="fehlerDialogHeader">
    <mat-icon>warning</mat-icon>
    <strong>Ein Fehler ist aufgetreten</strong>
  </div>
  <div [innerHTML]="this.data.message"></div>
</div>
